import React, { useContext, useEffect, useState } from 'react';
import { PlatformContext } from '../context/PlatformContext';
import MobileLayoutModern from '../mobile/components/MobileLayoutModern';
import DefaultLayout from './Layout';

const DynamicLayout = ({ children, isAuthScreen = false, hideFooter = false, noMainPadding = false }) => {
  const { platform, loading } = useContext(PlatformContext);
  const [layout, setLayout] = useState(null);

  useEffect(() => {
    if (!loading) {
      if (platform === 'mobileApp' || platform === 'mobileWeb') {
        setLayout('mobile');
      } else {
        setLayout('default');
      }
    }
  }, [platform, loading]);

  const LayoutComponent = layout === 'mobile' ? MobileLayoutModern : DefaultLayout;

  return (
    <LayoutComponent
      isAuthScreen={isAuthScreen}
      hideFooter={hideFooter}
      noMainPadding={noMainPadding}
    >
      {children}
    </LayoutComponent>
  );
};

export default DynamicLayout;
